module.exports = __webpack_public_path__ + "img/cash.b8e45780.svg";